import {useMemo} from "react";
import {useSelector} from "react-redux";

import {upperFirst} from "@pg-mono/nodash";

import {IRPStore} from "../../app/rp_reducer";
import {IPromotionRegion} from "../actions/fetch_promotion_list_region";
import {buildPromotionListUrlFromRegion} from "../helpers/build_promotion_list_url";
import {getPromotionListingConfig, getPromotionListingLocationLinkText, isPromotionListingType} from "../helpers/promotion_listing_config";
import {PromotionType} from "../helpers/PromotionType";

export const usePromotionTypeListByCurrentRegion = (currentPromotionType: PromotionType) => {
    const promotionsStatistic = useSelector((state: IRPStore) => state.promotionList.statistic);
    const region = useSelector((state: IRPStore) => state.promotionList.region);

    const availablePromotions = useMemo(() => {
        if (!region?.slug) {
            return [];
        }

        return (
            promotionsStatistic
                ?.map((promotionStatistic) => ({
                    type: promotionStatistic.type,
                    label: isPromotionListingType(promotionStatistic.type) ? getPromotionListingConfig(promotionStatistic.type).fullLabel : "",
                    count: promotionStatistic.count
                }))
                .filter(
                    (promotion) => !!promotion.label && promotion.count > 0 && promotion.type !== currentPromotionType && isPromotionListingType(promotion.type)
                ) || []
        );
    }, [region?.slug, promotionsStatistic]);

    const promotionLinks = useMemo(() => {
        if (!region?.slug) {
            return [];
        }

        return (
            availablePromotions?.map((promotion) => ({
                href: buildPromotionListUrlFromRegion({region, type: promotion.type}),
                text: getPromotionRegionLinkText(promotion.type, region)
            })) || []
        );
    }, [region?.slug, promotionsStatistic]);

    return {
        availablePromotions,
        promotionLinks
    };
};

const getPromotionRegionLinkText = (type: PromotionType, region: IPromotionRegion): string => {
    switch (type) {
        case PromotionType.DISCOUNT:
        case PromotionType.PRESALE:
        case PromotionType.LAST_MINUTE:
            return getPromotionListingLocationLinkText(type, region.short_name);
        default:
            return upperFirst(`${getPromotionListingConfig(type).fullLabel} ${region.name_declension_where}`);
    }
};
import {useMemo} from "react";
import {useSelector} from "react-redux";

import {upperFirst} from "@pg-mono/nodash";

import {IRPStore} from "../../app/rp_reducer";
import {IPromotionRegion} from "../actions/fetch_promotion_list_region";
import {buildPromotionListUrlFromRegion} from "../helpers/build_promotion_list_url";
import {getPromotionListingConfig, getPromotionListingLocationLinkText, isPromotionListingType} from "../helpers/promotion_listing_config";
import {PromotionType} from "../helpers/PromotionType";

export const usePromotionTypeListByCurrentRegion = (currentPromotionType: PromotionType) => {
    const promotionsStatistic = useSelector((state: IRPStore) => state.promotionList.statistic);
    const region = useSelector((state: IRPStore) => state.promotionList.region);

    const availablePromotions = useMemo(() => {
        if (!region?.slug) {
            return [];
        }

        return (
            promotionsStatistic
                ?.map((promotionStatistic) => ({
                    type: promotionStatistic.type,
                    label: isPromotionListingType(promotionStatistic.type) ? getPromotionListingConfig(promotionStatistic.type).fullLabel : "",
                    count: promotionStatistic.count
                }))
                .filter(
                    (promotion) => !!promotion.label && promotion.count > 0 && promotion.type !== currentPromotionType && isPromotionListingType(promotion.type)
                ) || []
        );
    }, [region?.slug, promotionsStatistic]);

    const promotionLinks = useMemo(() => {
        if (!region?.slug) {
            return [];
        }

        return (
            availablePromotions?.map((promotion) => ({
                href: buildPromotionListUrlFromRegion({region, type: promotion.type}),
                text: getPromotionRegionLinkText(promotion.type, region)
            })) || []
        );
    }, [region?.slug, promotionsStatistic]);

    return {
        availablePromotions,
        promotionLinks
    };
};

const getPromotionRegionLinkText = (type: PromotionType, region: IPromotionRegion): string => {
    switch (type) {
        case PromotionType.DISCOUNT:
        case PromotionType.PRESALE:
        case PromotionType.LAST_MINUTE:
            return getPromotionListingLocationLinkText(type, region.short_name);
        default:
            return upperFirst(`${getPromotionListingConfig(type).fullLabel} ${region.name_declension_where}`);
    }
};
